import { useDeliveryBarErrorsWithContext } from '@features/DeliveryBar/useDeliveryBarErrors';
import { ErrorTypes, useFeatureIsOn } from '@monofront/business/contexts';
import { ErrorModalIneligibleProductsInCart } from './ErrorModalIneligibleProductsInCart';
import { useDeliveryBar } from '@context/DeliveryBarContext';
import { ABTEST_DELIVERY_BAR } from '@monofront/business/constants';

const errorComponents = {
  [ErrorTypes.UNKNOWN_ERROR]: () => null,
  [ErrorTypes.INELIGIBLE_PRODUCTS_IN_CART]: ErrorModalIneligibleProductsInCart(
    'DeliveryBar.Errors.INELIGIBLE_PRODUCTS_IN_CART',
  ),
  [ErrorTypes.INELIGIBLE_PRODUCT_ADDED_TO_CART]:
    ErrorModalIneligibleProductsInCart(
      'DeliveryBar.Errors.INELIGIBLE_PRODUCT_ADDED_TO_CART',
      '/collections/pommes-de-terre-et-condiments-bio',
      true,
    ),
  [ErrorTypes.INELIGIBLE_SHIPPING_METHOD_SELECTED]:
    ErrorModalIneligibleProductsInCart(
      'DeliveryBar.Errors.INELIGIBLE_SHIPPING_METHOD_SELECTED',
    ),
};

const DeliveryBarError = () => {
  const { error } = useDeliveryBarErrorsWithContext();
  const { isSidePanelOpen } = useDeliveryBar();

  if (isSidePanelOpen) {
    return null;
  }

  const ErrorComponent =
    (error?.errorType && errorComponents?.[error.errorType]) || (() => null);

  return <ErrorComponent />;
};

const AbTestWrapper = () => {
  const isDeliveryBarABTestEnabled = useFeatureIsOn(ABTEST_DELIVERY_BAR);

  if (!isDeliveryBarABTestEnabled) {
    return null;
  }

  return <DeliveryBarError />;
};

export { AbTestWrapper as DeliveryBarError };
